export namespace AgroReportActions {
    export class GetSubventionReport {
        static readonly type = 'AgroReportActions.GetSubventionReport';

        constructor(public year?: number) {}
    }

    export class GetCumulationReport {
        static readonly type = 'AgroReportActions.GetCumulationReport';

        constructor(public date?: string) {}
    }

    export class GetCumulationPeriods {
        static readonly type = 'AgroReportActions.GetCumulationPeriods';
    }
}
